import { gql } from '@apollo/client';

export const CART_FIELDS = gql`
  fragment allCartFields on Cart {
    uuid
    recipientName
    funnelData
    orderOn
    userId
    tenantEligibilityConfigLogicalId
    deliveryDates
    status
    cartDeliveries {
      id
      createdAt
      updatedAt
      locationId
      status
      deliveryType
      estimatedTransitTime
      estimatedDeliveryDate
      deliveryDate
      lineItems {
        id
        createdAt
        updatedAt
        variantId
        variant
        price
        quantity
      }
    }
    cartLedger {
      id
      createdAt
      updatedAt
      subtotal
      discountTotal
      creditTotal
      deliveryTotal
      tax
      grandTotal
      precreditTotal
    }
    discount {
      amount
      code
      type
    }
  }
`;
